import { initialStockAdminApi } from '../../api';
import { InitialStockOverrideRequest } from '../../types/inventory/initialStockAdmin/InitialStockAdminTypes';

const InitialStockAdminService = {
  /**
   * 🔍 Lista (paginada) existencias por producto/sucursal, incluyendo las
   * que están en 0 o negativas — a diferencia del lookup normal de ventas.
   * GET /api/inventory/initial-stock-admin/search
   */
  search: async (params: {
    branchId?: number | null;
    term?: string;
    categoryId?: number | null;
    onlyNegative?: boolean;
    page?: number;
    size?: number;
  }) => {
    const query = new URLSearchParams();
    if (params.branchId) query.set('branchId', String(params.branchId));
    if (params.term && params.term.trim()) query.set('term', params.term.trim());
    if (params.categoryId) query.set('categoryId', String(params.categoryId));
    query.set('onlyNegative', String(!!params.onlyNegative));
    query.set('page', String(params.page ?? 0));
    query.set('size', String(params.size ?? 10));

    const response = await initialStockAdminApi.fetchCustom(`/search?${query.toString()}`);
    return response.data;
  },

  /**
   * ✏️ Sobrescribe cantidad y costo promedio de los productos seleccionados.
   * POST /api/inventory/initial-stock-admin/override
   */
  override: async (request: InitialStockOverrideRequest) => {
    const response = await initialStockAdminApi.addCustom('/override', request);
    return response.data;
  },
};

export default InitialStockAdminService;
